import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { mailCommand } from '../../../message/model/const/command';
import { SendTenantMailCommandHandler } from '../../../message/service/command/send-tenant-mail-command-handler.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { ApproveContractCommandHandler } from './approve-contact-command-handler.service';
import { CreateInvoiceCommandHandler } from './create-invoice-command-handler.service';
import { PrintContractCommandHandler } from './print-contract-command-handler.service';
import { PrintContractTerminationFormCommandHandler } from './print-contract-termination-form-command-handler';
import { PrintParkingContractFormCommandHandler } from './print-parkingcontract-command-handler';
import { ShowLeaseAgreementInvoicesCommandHandler } from './show-lease-agreement-invoices-command-handler';
import { TerminateContractCommandHandler } from './terminate-contract-command-handler.service';
import { WithdrawApprovalCommandHandler } from './withdraw-approval-command-handler.service';
import { WithdrawTerminationCommandHandler } from './withdraw-termination-command-handler.service';
import { LinkLeaseAgreementDocumentCommandHandler } from './link-lease-agreement-document-command-handler.service';
import { ShowDocumentsCommandHandler } from './show-documents-command-handler.service';
import { SendTenantSMSCommandHandler } from '../../../message/service/command/send-tenant-sms-command-handler.service';
import { VoidContractCommandHandler } from './void-contract-command-handler.service';
import { ESignLeaseAgreementContractCommandHandler } from './esign-lease-agreement-document-command-handler.service';
import { ESignKeyRecieptCommandHandler } from './esign-key-reciept-document-command-handler.service';
import { ContractFormCommandHandlerResolver } from './contract-form-command-handler-resolver.service';
import { TransferCooperativeHousingCommandHandler } from './transfer-cooperative-housing-command-handler.service';
import { SendTenantEmailCommandHandler } from '../../../message/service/command/send-tenant-email-command-handler.service';

@Injectable()
export class CooperativeHousingContractFormCommandHandlerResolver extends ContractFormCommandHandlerResolver {
  constructor(
    approveHandler: ApproveContractCommandHandler,
    createHandler: CreateCommandHandler,
    createInvoiceHandler: CreateInvoiceCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    linkDocumentHandler: LinkLeaseAgreementDocumentCommandHandler,
    printTerminationFormHandler: PrintContractTerminationFormCommandHandler,
    sendEmailHandler: SendTenantEmailCommandHandler,
    sendMailHandler: SendTenantMailCommandHandler,
    sendSmsHandler: SendTenantSMSCommandHandler,
    terminateHandler: TerminateContractCommandHandler,
    voidHandler: VoidContractCommandHandler,
    esignLeaseAgreementDocumentHandler: ESignLeaseAgreementContractCommandHandler,
    withdrawApprovalHandler: WithdrawApprovalCommandHandler,
    withdrawTerminationHandler: WithdrawTerminationCommandHandler,
    printContractCommandHandler: PrintContractCommandHandler,
    printParkingContractCommandHandler: PrintParkingContractFormCommandHandler,
    showDocumentsHandler: ShowDocumentsCommandHandler,
    showInvoicesHandler: ShowLeaseAgreementInvoicesCommandHandler,
    eSignKeyRecieptHandler: ESignKeyRecieptCommandHandler,
    transferHandler: TransferCooperativeHousingCommandHandler
  ) {
    super(
      approveHandler,
      createHandler,
      createInvoiceHandler,
      deleteHandler,
      linkDocumentHandler,
      printTerminationFormHandler,
      sendEmailHandler,
      sendMailHandler,
      sendSmsHandler,
      terminateHandler,
      voidHandler,
      esignLeaseAgreementDocumentHandler,
      withdrawApprovalHandler,
      withdrawTerminationHandler,
      printContractCommandHandler,
      printParkingContractCommandHandler,
      showDocumentsHandler,
      showInvoicesHandler,
      eSignKeyRecieptHandler
    );
    this.addHandler(leaseAgreementCommand.transferCooperativeHousing, transferHandler);
  }
}
